"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractiveStreamList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _PropTypes = require("../PropTypes");
var _InteractiveStreamListItem = require("./InteractiveStreamListItem");
var _InteractiveStreamList = require("./InteractiveStreamList.styled");
var InteractiveStreamList = exports.InteractiveStreamList = function InteractiveStreamList(_ref) {
  var streams = _ref.streams;
  return _react["default"].createElement(_InteractiveStreamList.Wrapper, null, streams.map(function (stream) {
    var featuredImage = stream.theme.featuredImage;
    return _react["default"].createElement(_InteractiveStreamListItem.InteractiveStreamListItem, (0, _extends2["default"])({
      key: stream._id
    }, stream, {
      featuredImage: featuredImage
    }));
  }));
};
InteractiveStreamList.propTypes = {
  streams: _PropTypes.InteractiveStreamListPropTypes
};